import { EnvironmentGroupId } from '@/react/portainer/environments/types';

export type ObservabilityMode = 'deploy-and-connect' | 'connect-only';

export type ObservabilityPreset = 'standard' | 'gke-autopilot' | 'eks-fargate';

export const OBSERVABILITY_PRESETS = [
  {
    value: 'standard' as const,
    label: 'Standard',
    description: 'Self-managed, EKS on EC2, GKE Standard, AKS',
  },
  {
    value: 'gke-autopilot' as const,
    label: 'GKE Autopilot',
    description: 'GKE Autopilot (no hostPath)',
  },
  {
    value: 'eks-fargate' as const,
    label: 'EKS Fargate',
    description: 'EKS Fargate (no hostPath)',
  },
] as const;

export interface ObservabilityDeployFormValues {
  ingestionKey: string;
  targetNamespace: string;
  helmReleaseName: string;
  preset: ObservabilityPreset;
}

export interface ObservabilityDetectionFormValues {
  expectedNamespace: string;
  helmReleaseName: string;
  clusterName: string;
}

export interface ObservabilityK8sFormValues {
  name: string;
  description: string;
  environmentGroupIds: Array<EnvironmentGroupId>;
  oneUptimeURL: string;
  apiKey: string;
  projectID: string;
  mode: ObservabilityMode;
  deploy: ObservabilityDeployFormValues;
  detection: ObservabilityDetectionFormValues;
  uiEnrichmentEnabled: boolean;
  tlsSkipVerify: boolean;
  autoRotateKey: boolean;
  // Transient UI state: tracks whether test connection passed for the current credentials.
  // Required to be true when autoRotateKey is enabled before the form can be submitted.
  connectionVerified: boolean;
}

export function buildObservabilityPayload(
  formValues: ObservabilityK8sFormValues
): ObservabilityK8sFormValues {
  return { ...formValues };
}

export const OBSERVABILITY_K8S_INITIAL_VALUES: ObservabilityK8sFormValues = {
  name: '',
  description: '',
  environmentGroupIds: [],
  oneUptimeURL: 'https://oneuptime.com',
  apiKey: '',
  projectID: '',
  mode: 'connect-only',
  deploy: {
    ingestionKey: '',
    targetNamespace: 'oneuptime-agent',
    helmReleaseName: 'kubernetes-agent',
    preset: 'standard' as ObservabilityPreset,
  },
  detection: {
    expectedNamespace: '',
    helmReleaseName: '',
    clusterName: '',
  },
  uiEnrichmentEnabled: false,
  tlsSkipVerify: false,
  autoRotateKey: false,
  connectionVerified: false,
};
